import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }             from '../api/api.service';
import { CompanyQuoteModel }      from '../companies/models/company.quote';
import { RepcoSettingsComponent } from './repco.settings.component';
import { RepcoSettingsModel }     from './typings/repco.settings';
import { SessionService }         from '../sessions/session.service';

export const RepcoStates : Array<NgHybridStateDeclaration> = [
  {
    component: RepcoSettingsComponent,
    name     : 'app.repco-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<any> => sessionService.refresh(),
        token    : 'session'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<RepcoSettingsModel> => apiService.get('/company'),
        token    : 'settings'
      },
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyQuoteModel> => apiService.get('/company/quote_for_repco'),
        token    : 'quote'
      }
    ],
    url: '/repco_settings'
  }
];
